import React, {Component} from 'react'
import JobsFilters from './JobsFilters'
import JobsTable from './JobsTable'
import {Pagination} from "antd"
import {printedFileSession} from "../../../services/api/3dApi"

class JobsGeneratedPage extends Component {
    state = {
        loading: false,
        error: '',
        message: '',
        listSession: [],
        page: 1,
        pages: 1,
        total: 0,
        limit: 50,
        filters: {
            status: '',
            created_at: ''
        }
    }

    componentDidMount() {
        this._fetchListingSessions()
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, () => {
            this._fetchListingSessions()
        })
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1
        }, () => {
            this._fetchListingSessions()
        })
    }

    _handleChangeSelect = (name, value) => {
        const newDate = (value.from === '' && value.to === '') ? '' : value
        this.setState({
            filters: {
                [name]: name === 'created_at' ? newDate : value
            }
        }, () => {
            this._fetchListingSessions()
        })
    }

    _fetchListingSessions = async () => {
        try {
            this.setState({
                loading: true,
                error: '',
            })

            const {filters, limit, page} = this.state
            const {status, created_at} = filters

            const payload = {
                limit,
                page,
                status,
                created_at
            }

            const {data: response} = await printedFileSession(payload)

            const {success, data, error} = response

            if (!success) {
                return this.setState({
                    error: error,
                    loading: false,
                    listSession: [],
                })
            }

            const {jobs, total} = data

            this.setState({
                loading: false,
                listSession: jobs,
                total,
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
            })
        }
    }

    render() {
        const {listSession, loading, error, page, total, limit, filters} = this.state

        return (
            <div className="listJobsGenerated">
                <JobsFilters
                    filters={filters}
                    onChangeSelect={this._handleChangeSelect}
                />
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        {
                            error && (<div className="text-danger">{error}</div>)
                        }
                    </div>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        showTotal={
                            (sum, range) => sum > 0 &&
                                <div>
                                    Hiển
                                    thị <strong>{range[0]}</strong> đến <strong>{range[1]}</strong> của <strong>{total}</strong> files
                                    upload
                                </div>
                        }
                        showQuickJumper
                        onChange={this._handlePageChange}
                        showSizeChanger
                        pageSizeOptions={['10', '20', '50', '100']}
                        onShowSizeChange={this._handleShowSizeChange}
                    />
                </div>
                <JobsTable loading={loading} listSession={listSession} reloadListSessions={this._fetchListingSessions}/>
                <Pagination
                    current={page}
                    total={total}
                    pageSize={limit}
                    showTotal={
                        (sum, range) => sum > 0 &&
                            <div>
                                Hiển
                                thị <strong>{range[0]}</strong> đến <strong>{range[1]}</strong> của <strong>{total}</strong> files
                                upload
                            </div>
                    }
                    showQuickJumper
                    onChange={this._handlePageChange}
                    className='text-right mb-3' showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onShowSizeChange={this._handleShowSizeChange}
                />
            </div>
        )
    }

}

export default JobsGeneratedPage
